import React, { useContext } from "react";
import { AuthContext } from "../../Auth/Context/AuthContext";
import { userRoles } from "../../config/EnVariables";
import Footer from "../../Components/Footer";
import { message } from "antd";

function Profile(props) {
  const { user } = useContext(AuthContext);
  return (
    <>
      <div
        class={
          user.role === userRoles.superadmin ? "container" : "page-wrapper"
        }
      >
        <div class="content">
          <div class="card">
            <div class="card-body">
              <div class="profile-set">
                <div class="profile-head"></div>
                <div class="profile-top">
                  <div class="profile-content">
                    <div class="profile-contentimg">
                      <img
                        src="/assets/img/user-avatar.png"
                        alt="img"
                        id="blah"
                      />
                      <div class="profileupload">
                        <input type="file" id="imgInp" />
                        <a href="#">
                          <img src="/assets/img/icons/edit-set.svg" alt="img" />
                        </a>
                      </div>
                    </div>
                    <div class="profile-contentname">
                      <h2>{user.username}</h2>
                      <h4>Updates Your Photo and Personal Details.</h4>
                    </div>
                  </div>
                  <div class="ms-auto">
                    <a
                      href="#"
                      class="btn btn-submit me-2"
                      onClick={() =>
                        message.warning("This feature will be added")
                      }
                    >
                      Save
                    </a>
                    <a href="/user-profile" class="btn btn-cancel">
                      Cancel
                    </a>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6 col-sm-12">
                  <div class="form-group">
                    <label>First Name</label>
                    <input
                      type="text"
                      placeholder="First Name"
                      value={user.username}
                    />
                  </div>
                </div>
                <div class="col-lg-6 col-sm-12">
                  <div class="form-group">
                    <label>Last Name</label>
                    <input
                      type="text"
                      placeholder="Last Name"
                      value={user.username}
                    />
                  </div>
                </div>
                <div class="col-lg-6 col-sm-12">
                  <div class="form-group">
                    <label>Email</label>
                    <input
                      type="text"
                      placeholder="example@example.com"
                      value={user.email}
                    />
                  </div>
                </div>
                <div class="col-lg-6 col-sm-12">
                  <div class="form-group">
                    <label>Phone</label>
                    <input
                      type="text"
                      placeholder="+1452 876 5432"
                      value={user.phone}
                    />
                  </div>
                </div>
                <div class="col-lg-6 col-sm-12">
                  <div class="form-group">
                    <label>Username</label>
                    <input
                      type="text"
                      placeholder="Username"
                      value={user.username}
                    />
                  </div>
                </div>
                <div class="col-lg-6 col-sm-12">
                  <div class="form-group">
                    <label>Password</label>
                    <div class="pass-group">
                      <input type="password" class=" pass-input" />
                      <span class="fas toggle-password fa-eye-slash"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default Profile;
